export type FileValidation = FileValidationSuccessful | FileValidationFailed;

export interface FileValidationFailed {
  message: string;
  state: 'invalidLocation' | 'duplicate' | 'invalidFileType' | 'invalidFileSize';
  success: false;
}

export interface FileValidationSuccessful {
  success: true;
}

export function validateFile(file: File, allowedFileTypes: string[], maxFileSize: number): FileValidation {
  // Check whether the file comes from the local computer
  if ((file.size === 0 && file.type === '') || !file.lastModified) {
    return {
      message: 'pages.transport.upload-dialog.errors.file-location',
      success: false,
      state: 'invalidLocation',
    };
  }

  // Check for allowed file types
  if (allowedFileTypes == null || !allowedFileTypes.includes(file.type)) {
    return {
      message: 'pages.transport.upload-dialog.errors.file-type',
      state: 'invalidFileType',
      success: false,
    };
  }

  // Check for maximum file size
  if (file.size > maxFileSize) {
    return {
      message: 'pages.transport.upload-dialog.errors.file-size',
      state: 'invalidFileSize',
      success: false,
    };
  }

  return { success: true };
}
